module.exports = __webpack_public_path__ + "static/media/vulnerable.a9a0b284.jpg";